<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-6 col-9">
            <h2>مدیریت سفارشات</h2>
            <ul class="breadcrumb mt-3">
              <li class="breadcrumb-item">
                <a href="Dashboard">
                  <i class="zmdi zmdi-home"></i>
                  <span>
                    پنل مدیریت
                  </span>
                </a>
              </li>

              <li class="breadcrumb-item active" style="padding-top: 2px;">
                <a href="#" @click="getOrders(pageIndex)">مدیریت سفارشات</a>
              </li>
              <!--              <li class="breadcrumb-item active">
                              <a href="#" ref="BreadCrumbTitle">
                                سفارش گذاری
                              </a>
                            </li>-->
            </ul>
            <!--            <button class="btn btn-primary btn-icon mobile_menu" type="button">
                          <i class="zmdi zmdi-sort-amount-desc"></i>
                        </button>-->
          </div>
          <div class="col-lg-5 col-md-6 col-sm-6 col-3">
            <button class="btn btn-primary float-right" type="button" @click="$store.state.menuShow=true">
              <i class="zmdi zmdi-menu align-middle"></i>
            </button>
            <!--            <div class="dropdown float-left">
                          <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                            دسترسی
                            <i class="zmdi zmdi-caret-down" style="vertical-align:middle;"></i>
                          </button>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#" @click="panelActive='ProductionPlanningDashboard'">برنامه ریزی
                              تولید</a>
                            <a class="dropdown-item" href="#" @click="panelActive='OrderingDashboard'">سفارش گذاری</a>
                            <a class="dropdown-item" href="#" @click="panelActive='InspectorsDashboard'">بازرسی</a>
                            <a class="dropdown-item" href="#" @click="panelActive='LogisticsDashboard'">شناسنامه ارسال محموله</a>
                            <a class="dropdown-item" href="#" @click="panelActive='ShipmentDashboard'">کارتابل ارسال محموله</a>
                          </div>
                        </div>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="فروشگاه جدید"
                            data-color="red"
                            data-toggle="modal"
                            @click="openNewShopModal()"
                        >
                          <i class="zmdi zmdi-plus align-middle"></i>
                          فروشگاه جدید
                        </button>-->
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="دانلود PDF لیست فروشگاه ها"
                            data-color="red"
                            data-toggle="modal"
                            @click="downloadShopList()"
                        >
                          <i class="zmdi zmdi-download align-middle"></i>
                          دانلود PDF لیست فروشگاه‌ها
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openNewContractModal">
                          قرارداد جدید
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openFindCustomerModal">
                          فیلتر گذاری
                        </button>-->
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
              <!--              <div class="row">
                              <div class="col-lg-12">
                                <select v-model="pageSize">
                                  <option value="10">10</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                </select>
                              </div>
                            </div>-->
              <div class="card mt-2">
                <!--                <div class="card-header bg-info">
                                  <div class="row">
                                    <div class="col">
                                      .:: فیلتر گذاری ::.
                                    </div>
                                    <div class="col text-left">
                                      <a href="#" class="text-dark" @click="closeFilterPanel" style="text-align: left">
                                        <small ref="a_CloseFilterPanel">
                                          نمایش
                                        </small>
                                      </a>
                                    </div>
                                  </div>
                                </div>-->
                <div class="card-body bg-white">

                  <form @submit.prevent="getOrdersByFilter">
                    <div class="row m-0 mb-2">
                      <!--                      <div class="col border p-0 pt-1 pb-2 m-2">
                                              <div class="col-md-12">
                                                <label class="form-label text-black">تامین کننده</label>
                                                <select
                                                    class="form-control show-tick ms select2"
                                                    data-placeholder="انتخاب کنید"
                                                    style="height:auto;" v-model="filterOrder.SupplierId">

                                                  <option value="678b97bab3f8164454040d18">
                                                    تولیدی صنعتی بهران موتور گلپایگان
                                                  </option>
                                                </select>
                                              </div>
                                            </div>-->

                    </div>
                    <div class="row m-0 mb-2">
                      <!--<div class="col-lg-6 col-md-6">
                      <div class="row">
                        <div class="col border p-0 pt-1 pb-2 m-2">
                          <div class="col">
                            <label class="form-label text-black">شماره فاکتور</label>
                            <input type="text" class="form-control text-left" v-model="filterOrder.InvoiceNumber">
                          </div>
                        </div>
                      </div>
                    </div>-->
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2">
                        <div class="col-md-12 border p-2">
                          <label class="form-label text-black">شماره فاکتور</label>
                          <input type="number" class="form-control text-left" v-model="filterOrders.InvoiceNumber">
                        </div>
                      </div>
                      <!--                      <div class="col border p-0 pt-1 pb-2 m-2">
                                              <div class="col-md-12">
                                                <label class="form-label text-black">تاریخ تحویل</label>
                                                <div class="row">
                                                  <div class="col">
                                                    <date-picker
                                                        type="date"
                                                        :autoSubmit="true"
                                                        format="YYYY-MM-DD"
                                                        display-format="jYYYY/jMM/jDD"
                                                        v-model="filterOrder.FromDate" placeholder="از تاریخ"
                                                        inputClass="form-control text-left"
                                                    ></date-picker>
                                                  </div>
                                                  <div class="col">
                                                    <date-picker
                                                        type="date"
                                                        :autoSubmit="true"
                                                        format="YYYY-MM-DD"
                                                        display-format="jYYYY/jMM/jDD"
                                                        v-model="filterOrder.ToDate" placeholder="تا تاریخ"
                                                        inputClass="form-control text-left"
                                                    ></date-picker>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>-->
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2">
                        <div class="col-md-12 border p-2">
                          <label class="form-label text-black">شماره همراه</label>
                          <input type="text" class="form-control text-left" v-model="filterOrders.MobileNumber">
                        </div>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2">
                        <div class="col-md-12 border p-2">
                          <label class="form-label text-black">نام مشتری</label>
                          <input type="text" class="form-control" v-model="filterOrders.CustomerName">
                        </div>
                      </div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2">
                        <div class="col-md-12 border p-2">
                          <div class="col p-0">
                            <label class="form-label text-black">کارتابل فعلی</label>
                            <select
                                class="form-control show-tick ms select2"
                                data-placeholder="انتخاب کنید"
                                style="height:auto;" v-model="filterOrders.CurrentOwner">
                              <option :value="0">
                                همه
                              </option>
                              <option :value="item.Id" v-for="(item,index) in orderStatus" :key="index">
                                {{ item.RoleTitle }}
                              </option>
                            </select>
                          </div>
                        </div>

                      </div>
                    </div>


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          فیلتر کن
                        </button>
                        <input type="button" class="btn btn-danger" value="پاک کردن فیلتر"
                               @click="getOrderWithoutFilter(1,20)">
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div v-for="(item) in ordersData.OrderList" :key="item.InvoiceId"
                     class="card border border-primary p-2">
                  <p>
                    <strong>
                      شماره فاکتور:
                    </strong>
                    <span>
                      {{ item.Number }}
                    </span>
                  </p>
                  <p>
                    <strong>
                      نام مشتری:
                    </strong>
                    <a style="cursor: pointer;color:#2e72ce;" @click="openCustomerInfoModal(item.CustomerPartyRef)">
                      {{ item.CustomerRealName }}
                    </a>
                  </p>
                  <p style="position: relative;">
                    <strong>
                      وضعیت رسیدگی:
                    </strong>
                    <a style="cursor: pointer;top:0;position: absolute;margin-right: 5px;"
                       v-if="item.IsInvoiceMissing===2">
                      <i class="zmdi zmdi-check-circle" style="color: #f3a907;font-size: 25px;"></i>
                    </a>
                    <a style="cursor: pointer;top:0;position: absolute;margin-right: 5px;"
                       v-if="item.IsInvoiceMissing===1">
                      <i class="zmdi zmdi-check-circle" style="color: #18e011;font-size: 25px;"></i>
                    </a>
                    <a style="cursor: pointer;top:0;position: absolute;margin-right: 5px;"
                       v-if="item.IsInvoiceMissing===0">
                      <i class="zmdi zmdi-circle-o" style="color: #1CBFD0;font-size: 25px;"></i>
                    </a>
                  </p>
                  <p>
                    <strong>
                      تاریخ ثبت اولیه:
                    </strong>
                    <span>
                      {{
                        $formatDateTime(item.CreationDate) | moment("HH:mm-jYYYY/jMM/jDD")
                      }}
                    </span>
                  </p>
                  <p>
                    <strong>
                      تاریخ تغییر وضعیت:
                    </strong>
                    <span>
                      {{
                        $formatDateTime(item.Date) | moment("jYYYY/jMM/jDD")
                      }}
                    </span>
                  </p>
                  <p>
                    <strong>
                      تعداد اقلام:
                    </strong>

                    <a style="cursor: pointer;" @click="getItemOrders(item.InvoiceId)">
                      {{
                        item.InvoiceItemCount
                      }}</a>

                  </p>
                  <p style="position: relative;">
                    <strong>
                      عملیات:
                    </strong>

                    <a @click="openHandlingOrderModal(item.InvoiceId,shipmentType='Delivery')"
                       style="cursor: pointer;top:0;position: absolute;margin-right: 5px;" title="رسیدگی سفارش">
                      <i class="zmdi zmdi-long-arrow-right" style="color: #1CBFD0;font-size: 25px;"></i>
                    </a>
                    &nbsp;
<!--                    <a @click="openHandlingOrderModal(item.InvoiceId,shipmentType='Return')"
                       style="cursor: pointer;top:0;position: absolute;margin-right: 35px;" title="برگشت کالا">
                      <i class="zmdi zmdi-long-arrow-return" style="color: #1CBFD0;font-size: 25px;"></i>
                    </a>-->

                    <a target="_blank" :href="'http://192.168.1.201:8080/ReportServer/Pages/ReportViewer.aspx?%2f%da%86%d8%a7%d9%be+%d9%81%d8%a7%da%a9%d8%aa%d9%88%d8%b1&rs:Command=Render&OrderId='+item.InvoiceId"
                       style="cursor: pointer;top:0;position: absolute;margin-right: 30px;" title="چاپ سفارش">
                      <i class="zmdi zmdi-print" style="color: #1CBFD0;font-size: 25px;"></i>
                    </a>

                  </p>
                </div>
                <!--                <div class="table-responsive">
                    <table
                        class="table table-bordered table-striped table-hover">
                      <thead class="bg-info">
                      <tr>
                        <th class="text-center">ردیف</th>
                        <th class="text-center">شماره فاکتور</th>
                        <th class="text-center">نام مشتری</th>
                        <th class="text-center">وضعیت رسیدگی</th>
                        <th class="text-center">تاریخ ثبت</th>
                        <th class="text-center">تعداد اقلام</th>
                        <th class="text-center">عملیات</th>
                      </tr>
                      </thead>
                      <tbody class="text-center">
                      <tr v-if="ordersData.OrderList.length===0">
                        <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                      </tr>
                      <tr v-for="(item,index) in ordersData.OrderList" :key="item.InvoiceId">
                        <td class="p-1 align-middle">{{ index + 1 }}</td>
                        <td class="p-1 align-middle">{{ item.Number }}</td>
                        <td class="p-1 align-middle">
                          <a style="cursor: pointer;color:#2e72ce;" @click="openCustomerInfoModal(item.CustomerPartyRef)">
                            {{ item.CustomerRealName }}
                          </a>
                        </td>
                        <td class="p-1 align-middle">
                          <a style="cursor: pointer;" v-if="item.IsInvoiceMissing===2">
                            <i class="zmdi zmdi-check-circle" style="color: #f3a907;font-size: 25px;"></i>
                          </a>
                          <a style="cursor: pointer;" v-if="item.IsInvoiceMissing===1">
                            <i class="zmdi zmdi-check-circle" style="color: #18e011;font-size: 25px;"></i>
                          </a>
                          <a style="cursor: pointer;" v-if="item.IsInvoiceMissing===0">
                            <i class="zmdi zmdi-circle-o" style="color: #1CBFD0;font-size: 25px;"></i>
                          </a>
                        </td>
                        <td class="p-1 align-middle">
                          {{
                            $formatDateTime(item.CreationDate) | moment("jYYYY/jM/jDD-HH:mm")
                          }}
                        </td>
                        <td class="p-1 align-middle">
                          <a style="cursor: pointer;" @click="getItemOrders(item.InvoiceId)">
                            {{
                              item.InvoiceItemCount
                            }}</a>
                        </td>
                        <td class="p-1 align-middle">
                          <a @click="openHandlingOrderModal(item.InvoiceId,shipmentType='Delivery')"
                             style="cursor: pointer;" title="ارسال کالا">
                            <i class="zmdi zmdi-long-arrow-right" style="color: #1CBFD0;font-size: 25px;"></i>
                          </a>
                          &nbsp;
                          <a @click="openHandlingOrderModal(item.InvoiceId,shipmentType='Return')"
                             style="cursor: pointer;" title="برگشت کالا">
                            <i class="zmdi zmdi-long-arrow-return" style="color: #1CBFD0;font-size: 25px;"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <paginate
                :page-count="pageList"
                :click-handler="getOrders"
                :prev-text="'prev'"
                :next-text="'next'" :page-range="5"
                :container-class="'custom-pagination'">
            </paginate>
          </div>
        </div>


      </div>
    </div>

    <div class="modal fade" id="div_AlertModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_AlertModalMessage"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_CustomerInfoModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_CustomerInfo"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="div_ReportTestModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">لیست اقلام</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-striped table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">عنوان</th>
                            <th class="text-center">تعداد</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in pendingOrderData.PendingOrderList" :key="index">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">{{ item.Title }}</td>
                            <td class="p-1 align-middle">{{ item.Quantity }}</td>

                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>
          <!--          <div class="modal-footer">
                      <div class="row">
                        <div class="col text-right" style="direction: rtl;">
                          <button class="btn btn-primary" @click="shipmentVerification">
                            تایید محموله
                          </button>
                        </div>
                      </div>
                    </div>-->
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_HandlingModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">اقلام فاکتور</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body p-0">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12 p-0">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-striped table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">عنوان</th>
                            <th class="text-center">تعداد</th>
                            <th class="text-center">ارسال/برگشت</th>
                            <th class="text-center">حمل رایگان</th>
                            <th class="text-center">نصب رایگان</th>
                            <th class="text-center">شعبه</th>
                            <th class="text-center">توضیحات</th>
                            <th class="text-center">کارتابل</th>
                            <th class="text-center">وضعیت فعلی</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in pendingOrderData.PendingOrderList" :key="index"
                              :style="item.IsOwner === 0 ? { backgroundColor: '#f8d7da' } : {}">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">

                              <a href="#" :title="item.Description">{{ item.Title }}</a>
                            </td>
                            <td class="p-1 align-middle">{{ item.Quantity }}</td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example" required
                                      v-model="item.ShipmentType" :disabled="!item.IsOwner">
                                <option value="Delivery" class="text-success">ارسال</option>
                                <option value="Return" class="text-danger">برگشت</option>
                                <option value="Repair" class="text-warning">تعمیر</option>
                              </select>
                            </td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example" required
                                      v-model="item.IsFreeShipping" :disabled="!item.IsOwner">
                                <option :value="null" disabled>انتخاب کنید</option>
                                <option :value="false">ندارد</option>
                                <option :value="true">دارد</option>
                              </select>
                            </td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example" required
                                      v-model="item.IsFreeInstallation" :disabled="!item.IsOwner">
                                <option :value="null" disabled>انتخاب کنید</option>
                                <option :value="false">ندارد</option>
                                <option :value="true">دارد</option>
                              </select>
                            </td>
                            <td class="p-1 align-middle">{{ item.Branch }}</td>
                            <td class="p-1 align-middle">
                              <a style="cursor: pointer;" @click="openNewNoteModal(item.InvoiceItemId)">
                                <i class="zmdi zmdi-plus" style="color: #5698f5;font-size: 25px;"></i>
                              </a>
                              &nbsp;
                              <a style="cursor: pointer;" @click="openInvoiceNotesListModal(item.InvoiceItemId)">
                                <i class="zmdi zmdi-menu" style="color: #5698f5;font-size: 25px;"></i>
                              </a>
                            </td>

                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example"
                                      v-model="item.CurrentOwner"
                                      @change="onPermissionChange(item.Permission,item.CurrentOwner)"
                                      :disabled="!item.IsOwner">
                                <option :value="per.RoleId" v-for="(per,index) in uniquePermissions(item.Permission)"
                                        :key="index">
                                  {{ per.RoleTitle }}
                                </option>
                              </select>
                            </td>
                            <td class="p-1 align-middle">
                              <select class="form-control w-auto" aria-label="Default select example"
                                      v-model="item.Status" :disabled="!item.IsOwner">
                                <option :value="per.PermissionId"
                                        v-for="(per,index) in onPermissionChange(item.Permission,item.CurrentOwner)"
                                        :key="index">
                                  {{ per.Title }}
                                </option>
                              </select>
                            </td>

                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;">
                <button class="btn btn-primary" @click="handlingOrder">
                  ثبت تغییرات
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="div_NewNoteModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">یادداشت جدید</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:450px;">
              <div>
                <form @submit.prevent="saveNote">

                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">گیرنده</label>
                      <select
                          class="form-control show-tick ms select2"
                          data-placeholder="انتخاب کنید"
                          style="height:auto;" v-model="newNote.RoleId" required>
                        <option :value="item.Id" v-for="(item,index) in orderStatus" :key="index">
                          {{ item.RoleTitle }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!--<div class="row m-0 mb-2">
                  <div class="col border p-2 pt-1 pb-2 m-2">
                    <label class="form-label text-black">گیرنده</label>
                    <select class="form-control" v-model="newNote.UserId" aria-label="Default select example">
                      <option :value="item.Id" v-for="item in users" :key="item.Id" :selected="item.Selected">
                        {{ item.FullName }}
                      </option>
                    </select>
                  </div>
                </div>-->
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">زمان یادآوری</label>
                      <date-picker
                          type="datetime"
                          :autoSubmit="true"
                          format="YYYY-MM-DD HH:mm"
                          display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                          v-model="newNote.ReminderDate"
                      ></date-picker>
                    </div>
                  </div>

                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">یادداشت</label>
                      <textarea rows="5" class="form-control text-right" v-model="newNote.Note" required></textarea>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-right" style="direction: rtl;text-align: right;">
                      <button class="btn btn-success" type="submit">
                        ثبت
                      </button>
                      <button class="btn btn-danger" data-dismiss="modal">
                        انصراف
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>

        </div>
      </div>
    </div>


    <div class="modal fade" id="div_InvoiceNotesListModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">یادداشت ها</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div class="border border-success rounded rounded-3 p-1 mb-3" v-for="(item,index) in notes" :key="index">
                <div class="row">
                  <div class="col-lg-12">
                    <p>
                      <strong>
                        شماره فاکتور:
                      </strong>
                      {{ item.Number }}
                    </p>
                    <p>
                      <strong>
                        عنوان قلم:
                      </strong>
                      {{ item.Title }}
                    </p>
                    <p>
                      <strong>
                        یاداداشت:
                      </strong>
                      {{ item.Note }}
                    </p>
                    <p>
                      <strong>
                        فرستنده:
                      </strong>
                      {{ item.Sender }}
                    </p>
                    <p style="text-align: left;" class="mb-0">
                      <small>
                        {{ $formatDateTime(item.CreationDate) | moment("jYYYY/jM/jD-HH:mm") }}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </simplebar>

          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;text-align: right;">
                <!--                    <button class="btn btn-success">
                                      ثبت محموله
                                    </button>-->
                <button class="btn btn-danger" data-dismiss="modal">
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="modal fade" id="div_EditShipmentModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">ویرایش محموله</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div class="row bg-light p-2 mb-3">
                <div class="col">
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        نام سازنده:
                      </span>
                      {{ shipment?.SupplierDetail?.SupplierTitle }}
                    </div>
                    <div class="col">
                      <span>
                        کد سازنده:
                      </span>
                      {{ shipment?.SupplierDetail?.SupplierCode }}
                    </div>
                    <div class="col">
                      <span>
                        شماره محموله:
                      </span>
                      {{ shipment?.ShipmentNumber }}

                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        مشتری:
                      </span>
                      {{ shipment?.CustomerDetails?.CustomerTitle }}
                    </div>
                    <div class="col">
                      <span>
                        محل تحویل:
                      </span>
                      {{ shipment?.WarehouseDetail?.WarehouseTitle }}
                    </div>
                    <div class="col">

                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        تاریخ ثبت:
                      </span>
                      {{ shipment?.CreatedAt | moment("jYYYY/jM/jD") }}
                    </div>
                    <div class="col">
                      <span>
                        تاریخ تحویل:
                      </span>
                      {{ shipment?.EstimatedArrivalTime | moment("jYYYY/jM/jD") }}
                    </div>
                    <div class="col">
                      <span>
                        تاریخ بازرسی:
                      </span>
                      {{ shipment?.ConfirmedAt | moment("jYYYY/jM/jD") }}
                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <form class="form-inline">
                        <div class="form-group mb-2">
                          <label for="staticEmail2">شماره حواله سازنده: </label>
                          &nbsp;
                          <input type="text" class="form-control" v-model="shipment.ShipmentNumber">
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                          <label for="inputPassword2">توضیحات: </label>
                          &nbsp;
                          <input type="text" class="form-control" id="inputPassword2" v-model="shipment.Desc">
                        </div>
                      </form>
                    </div>


                  </div>
                </div>
              </div>
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">شرح قطعه</th>
                            <th class="text-center">شماره فنی</th>
                            <th class="text-center">کد کالا</th>
                            <th class="text-center">تعداد ارسالی</th>
                            <th class="text-center">گواهی مرغوبیت</th>
                            <th class="text-center">ابطال</th>
                            <th class="text-center">وضعیت</th>
                            <th class="text-center">آخرین بروزرسانی</th>
                            <th class="text-center">TestReport</th>
                            <th class="text-center">تعداد نهایی</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in shipment?.PendingOrder" :key="index"
                              :class="{'disabled-row': !completeAbandonButtonVisible || !orderItemsStatus(item.Status)}">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                            <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                            <td class="p-1 align-middle">{{ item.ItemCode }}</td>
                            <td class="p-1 align-middle">{{ item.OrderQuantity }}</td>
                            <td class="p-1 align-middle">{{ item.QualityCertificate }}</td>
                            <td class="p-1 align-middle">
                              <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                                     @change="addToAbandonList(item, $event)">
                            </td>
                            <td class="p-1 align-middle">
                              <span class="text-success">
                                <i class="zmdi zmdi-flag"></i>
                              </span>
                            </td>

                            <td class="p-1 align-middle">
                              <span v-if="item.UpdatedAt!=null">
                                {{ item.UpdatedAt | moment("jYYYY/jM/jD-HH:mm") }}
                              </span>
                            </td>
                            <td class="p-1 align-middle">
                              <span v-if="item.TestReport===null">
                                ندارد
                              </span>
                              <a href="#" target="_blank" v-else>
                                نمایش
                              </a>

                            </td>
                            <td class="p-1 align-middle">
                              <div class="d-flex align-items-center">
                                <input type="number" class="form-control" min="1" v-model="item.OrderQuantity"
                                       style="width:100px;text-align: left;direction: ltr;">
                                &nbsp;
                                <button type="button" class="btn btn-success"
                                        @click="updateOrderQuantity(item._id,item.OrderQuantity)"
                                        style="display: inline;">
                                  ثبت
                                </button>
                              </div>

                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;">
                <button type="button" class="btn btn-danger" @click="cancelOrderItems" v-if="cancelOrderItemsButtonVisible">
                  ابطال انتخابی ها
                </button>
                <button type="button" class="btn btn-danger" @click="completeAbandonment"
                        v-if="completeAbandonButtonVisible">
                  ابطال کل محموله
                </button>
                <button class="btn btn-primary" data-dismiss="modal">
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!--    <div class="modal fade" id="div_NewPendingOrderModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">محموله جدید</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شرح قطعه</label>
                          <input type="text" class="form-control text-right" v-model="newShipment.PartDescription">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.PartNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ItemCode">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;" min="1"
                                 v-model="newShipment.PalletQuantity">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع پالت</label>
                          <select class="form-control" v-model="newShipment.PalletType">
                            <option value="MS174">پالت نوع 1</option>
                            <option value="MS175">پالت نوع 2</option>
                            <option value="MS176">پالت نوع 3</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان آزاد سازی</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ReleaseTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان اعتبار</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ValidTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره محموله</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ShipmentNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">مشتری</label>
                          <select class="form-control" v-model="newShipment.CustomerId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">انبار</label>
                          <select class="form-control" v-model="newShipment.WarehouseId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">{{
                                item.WarehouseTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">خودرو</label>
                          <select class="form-control" v-model="newShipment.VehicleId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">{{
                                item.VehicleTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع ارسال</label>
                          <select class="form-control" v-model="newShipment.ShippingType">
                            <option value="کانبان مشتری">کانبان مشتری</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد در پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.QuantityPerPallet">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.Quantity">
                        </div>
                      </div>
                    </form>
                  </div>
                </simplebar>

              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col text-right" style="direction: rtl;text-align: right;">
                    <button class="btn btn-success" @click="addNewPendingOrder">
                      ثبت محموله
                    </button>
                    <button class="btn btn-danger" data-dismiss="modal">
                      انصراف
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from "vuejs-paginate";
// import Vue from 'vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

// import moment from "vue-moment-jalaali";
// import VueUploadMultipleImage from 'vue-upload-multiple-image';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  data() {
    return {
      order: {
        Orders: [],
        InvoiceNumber: null,
        EstimatedArrivalTime: null,
        OrderDescription: null,
        CustomerId: null,
        WarehouseId: null,
        SupplierId: null,
        VehicleId: null
      },
      isOpenFilterPanel: false,
      pendingOrdersData: {PendingOrderList: [], PendingOrdersCount: 0},
      loadingShow: false,
      pageSize: 10,
      pageList: 0,
      pageIndex: 0,
      filterPendingOrders: {
        CustomerId: null,
        WarehouseId: null,
        SupplierId: null,
        VehicleId: null
      },
      filterOrder: false,
      filterOrders: {
        FromDate: null,
        ToDate: null,
        InvoiceNumber: "",
        CurrentOwner: 0,
        MobileNumber: "",
        CustomerName: ""
      },
      ordersData: {OrderList: [], OrdersCount: 0},
      permissions: [],
      subPermissions: [],
      filterPermissions: [],
      newNote: {
        ReminderDate: null,
        Note: null,
        InvoiceItemId: null,
        UserId: null,
        RoleId: null
      },
      shipmentType: '',
      users: [],
      notes: {},
      orderStatus: [],

      /*newShipment: {
        CustomerId: null,
        WarehouseId: null,
        VehicleId: null,
        PartDescription: null,
        PartNumber: null,
        ItemCode: null,
        PalletQuantity: 1,
        PalletType: null,
        ReleaseTime: null,
        ValidTime: null,
        ShipmentNumber: null,
        QuantityPerPallet: 1,
        ShippingType: null,
        Quantity: 1,
        QuantityShipped: 1
      },*/

      /*filterWaybill: {
        CustomerId: null,
        WarehouseId: null,
        FromDate: null,
        ToDate: null,
        OrderStatus: null,
        ShipmentNumber: null,
        InvoiceNumber: null
      },*/

      // shipment: {},
      orderId: null,
      abandonList: [],
      // panelActive: "",
      pendingOrderData: {PendingOrderList: [], PendingOrderCount: 0},
      ordersNotInWaybillsData: {OrdersNotInWaybillsList: [], OrdersNotInWaybillsCount: 0},
      uploadTestFile: {
        OrderId: null,
        ItemId: null,
        TestReportFile: null
      },
      customers: [],
      vehicleList: [],
      warehouseList: [],
    };
  },
  methods: {
    /*formatJalali(date) {
      return date.substring(0, 10) + " " + date.substring(11, 16);
    },*/
    getStatusList() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("https://araksolar.ir/webhook/GetStatusList", {
            headers: {
              authorization: userInfo.Token
            },
            params: {}
          })
          .then(function (res) {
            console.log(res.data);
            self.orderStatus = res.data;
            //self.notes = res.data;
            //self.notes = res.data;
            //self.loadingShow = false;
            //console.log("لیست ماژول ها", response.data);
            //self.userModules = response.data.Data;
          })
          .catch(function (error) {
            //self.loadingShow = false;
          });
    },
    getInvoiceNoteById(id) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios
          .get("https://araksolar.ir/webhook/GetInvoiceNoteById", {
            headers: {
              authorization: userInfo.Token
            },
            params: {
              Id: id
            }
          })
          .then(function (res) {
            console.log(res.data);
            self.notes = res.data;
            //self.notes = res.data;
            self.loadingShow = false;
            //console.log("لیست ماژول ها", response.data);
            //self.userModules = response.data.Data;
          })
          .catch(function (error) {
            self.loadingShow = false;
          });
    },
    openInvoiceNotesListModal(id) {
      let self = this;
      self.getInvoiceNoteById(id);
      $("#div_InvoiceNotesListModal").modal({backdrop: "static"});
    },
    uniquePermissions(permissions) {
      const unique = [];
      const map = new Map();
      for (const per of permissions) {
        if (!map.has(per.RoleId)) {
          map.set(per.RoleId, true);
          unique.push(per);
        }
      }
      return unique;
    },
    getOrderWithoutFilter() {
      let self = this;
      self.filterOrder = false;
      self.filterOrders.CurrentOwner = 0;
      self.filterOrders.CustomerName = "";
      self.filterOrders.MobileNumber = "";
      self.filterOrders.InvoiceNumber = "";

      self.getOrders(1, 20);
    },
    getOrdersByFilter() {
      let self = this;
      self.filterOrder = true;
      self.getOrders(1, 20);
    },
    saveNote() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("https://araksolar.ir/webhook/SaveInvoiceNote", {
        Note: self.newNote
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);
            self.loadingShow = false;

            if (Status === 1) {

              $("#div_NewNoteModal").modal("hide");
              //self.getOrders(self.pageIndex);
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "error",
                duration: 5000
              });
              // self.$refs.div_AlertModalMessage.innerHTML = Message;
              // $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            // console.log("TEST");
            self.loadingShow = false;
          });
    },
    openNewNoteModal(InvoiceItemId) {
      let self = this;
      self.newNote.InvoiceItemId = InvoiceItemId;
      self.newNote.RoleId=null;
      self.newNote.UserId=null;
      //self.newNote.ReminderDate=moment().format("YYYY-MM-DD HH:mm");
      self.newNote.Note=null;
      const now = new Date();
      const pad = (n) => n.toString().padStart(2, "0");

      self.newNote.ReminderDate =
          now.getFullYear() + "-" +
          pad(now.getMonth() + 1) + "-" +
          pad(now.getDate()) + " " +
          pad(now.getHours()) + ":" +
          pad(now.getMinutes());

      self.getUsers();
      $("#div_NewNoteModal").modal("show");
    },
    onPermissionChange(permission, permissionId) {
      let self = this;
      console.log(permissionId);
      return permission.filter(sub => sub.RoleId === permissionId);
      // console.log(self.permissions.filter(sub => sub.RoleId === permissionId)) ;
    },
    handlingOrder() {
      let self = this;
      //console.log(self.pendingOrderData.PendingOrderList);

      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("https://araksolar.ir/webhook/HandlingOrder", {
        ItemList: self.pendingOrderData.PendingOrderList
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data[0];
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              self.getOrders(self.pageIndex);
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
              $("#div_HandlingModal").modal("hide");

            } else {
              self.loadingShow = false;
              // self.$refs.div_AlertModalMessage.innerHTML = Message;
              // $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            console.log("TEST")
            self.loadingShow = false;
          });
    },
    openCustomerInfoModal(partyRef) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("https://araksolar.ir/webhook/GetCustomerInfo", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        },
        params: {
          PartyRef: partyRef
        }
      })
          .then(function (res) {
            // let {Data, Message, Status} = res.data;
            console.log(res.data);
            self.$refs.div_CustomerInfo.innerHTML = `<p><strong>آدرس: </strong>${res.data[0].Address}</p>`;
            self.$refs.div_CustomerInfo.innerHTML += `<p><strong>تلفن: </strong><a href="tel:${res.data[0].Phone}">${res.data[0].Phone}</a></p>`;
            $("#div_CustomerInfoModal").modal({backdrop: "static"});
            self.loadingShow = false;
            //$("#div_CustomerInfo").modal("show");
            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    openHandlingOrderModal(invoiceId, shipmentType) {
      let self = this;
      console.log(invoiceId);
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.shipmentType = shipmentType;
      self.loadingShow = true;
      axios.get("https://araksolar.ir/webhook/GetOrderItems", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        },
        params: {
          InvoiceId: invoiceId
        }
      })
          .then(function (res) {
            // let {Data, Message, Status} = res.data;
            console.log("Result Is:");
            console.log(res.data);

            self.pendingOrderData.PendingOrderList = res.data.invoiceItems;
            /*self.pendingOrderData.PendingOrderList = self.pendingOrderData.PendingOrderList.map(item => ({
              ...item,
              ShipmentType: shipmentType
            }));*/
            //console.log(self.pendingOrderData.PendingOrderList)
            //self.permissions = res.data.permission;
            //self.subPermissions=res.data.subPermission;
            /*self.filterPermissions = res.data.permission;
            self.permissions = Object.values(
                res.data.permission.reduce((acc, current) => {
                  acc[current.RoleId] = current;
                  return acc;
                }, {})
            );*/

            self.loadingShow = false;
            $("#div_HandlingModal").modal("show");
            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    getItemOrders(invoiceId) {
      let self = this;
      // let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("https://araksolar.ir/webhook/4e25964c-9f6e-469a-aa33-5da3be7614a6", {
        headers: {
          'Content-Type': 'application/json',
          // Authorization: userInfo.Token
        },
        params: {
          InvoiceId: invoiceId
        }
      })
          .then(function (res) {
            // let {Data, Message, Status} = res.data;
            console.log("Result Is:");
            console.log(res.data);
            self.pendingOrderData.PendingOrderList = res.data;
            self.loadingShow = false;
            $("#div_ReportTestModal").modal("show");
            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    getOrders(pageIndex = 1, limit = 20) {
      let self = this;
      //console.log(pageIndex);
      self.pageIndex = pageIndex;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.post("https://araksolar.ir/webhook/GetOrders", {
        Page: pageIndex,
        Limit: limit,
        FilterOrder: self.filterOrder,
        Filter: self.filterOrders
        //InvoiceNumber: invoiceNumber,
        //CurrentOwner: currentOwner
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            // let {Data, Message, Status} = res.data;
            console.log(res.data);
            self.ordersData.OrderList = res.data[0].invoices;
            let pageCount =
                res.data[0].invoiceCount % 20 === 0
                    ? res.data[0].invoiceCount / 20
                    : res.data[0].invoiceCount / 20 + 1;
            self.pageList = Math.floor(pageCount);
            self.loadingShow = false;


            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    getUsers() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("https://araksolar.ir/webhook/GetUsers", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        },
        params: {}
      })
          .then(function (res) {
            console.log(res.data);
            self.users = res.data;
            // let {Data, Message, Status} = res.data;
            // console.log(res.data);
            // self.$refs.div_CustomerInfo.innerHTML = `<p><strong>آدرس: </strong>${res.data[0].Address}</p>`;
            // self.$refs.div_CustomerInfo.innerHTML += `<p><strong>تلفن: </strong>${res.data[0].Phone}</p>`;
            //$("#div_CustomerInfoModal").modal({backdrop: "static"});
            //self.loadingShow = false;
            //$("#div_CustomerInfo").modal("show");
            /*if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }*/
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },
    /* selectReportTestFile(itemId) {
       let self = this;
       self.uploadTestFile.ItemId = itemId;
       this.$refs.fileInput[0].click();
     },*/
    /*shipmentVerification() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      // self.uploadTestFile.ItemId = itemId;
      axios.post("/API/V1/Orders/ShipmentVerification", self.uploadTestFile, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              $("#div_ReportTestModal").modal("hide");
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },*/
    /*uploadTestReport(event) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      const testReportFile = event.target.files[0];
      console.log(testReportFile);
      const formData = new FormData();
      formData.append('TestReportFile', testReportFile);
      formData.append('OrderId', self.uploadTestFile.OrderId);
      formData.append('ItemId', self.uploadTestFile.ItemId);
      axios.post("/API/V1/Orders/UploadTestReport", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
              if (itemToUpdate) {
                itemToUpdate.TestReport = Data.FileName;
                itemToUpdate.UpdatedAt = Data.UpdatedAt;
              }
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });

            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },*/
    /*openReportTestModal(pendingOrder, orderId) {
      let self = this;
      self.uploadTestFile.OrderId = orderId;
      self.pendingOrderData.PendingOrderList = pendingOrder;
      $("#div_ReportTestModal").modal("show");
    },*/
    /*filterOrders() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("/API/V1/Orders/FilterOrders", {
        params: self.filterOrder,
        headers: {
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Status, Message, Data} = res.data;
            console.log(res.data);
            if (Status === 1) {
              self.ordersData.OrderList = Data.OrderList
            } else {
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },*/
    closeFilterPanel() {
      let self = this;
      self.isOpenFilterPanel = !self.isOpenFilterPanel;
      self.$refs.a_CloseFilterPanel.innerText = self.isOpenFilterPanel === true ? "بستن" : "نمایش";
    },

    /*getCustomersInfo() {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      axios.get("/API/V1/Customers/GetCustomers", {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(res.data);

            if (Status === 1) {
              self.loadingShow = false;
              self.customers = Data.Customers;
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },*/
    /*removeTestReport(itemId) {
      let self = this;
      let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
      self.loadingShow = true;
      self.uploadTestFile.ItemId = itemId;
      axios.post("/API/V1/Orders/RemoveTestReport", self.uploadTestFile, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: userInfo.Token
        }
      })
          .then(function (res) {
            let {Data, Message, Status} = res.data;
            console.log(Data);

            if (Status === 1) {
              self.loadingShow = false;
              const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
              if (itemToUpdate) {
                itemToUpdate.TestReport = null;
                itemToUpdate.UpdatedAt = Data.UpdatedAt
              }
              self.$toast.open({
                position: "bottom-right",
                message: Message,
                type: "success",
                duration: 5000
              });
            } else {
              self.loadingShow = false;
              self.$refs.div_AlertModalMessage.innerHTML = Message;
              $("#div_AlertModal").modal({backdrop: "static"});
            }
          })
          .catch(function (error) {
            console.log(error);
            self.loadingShow = false;
          })
          .finally(function (res) {
            self.loadingShow = false;
          });
    },*/
  },
  created() {
    let self = this;
    self.getOrders();
    self.getStatusList();
    // this.getCustomersInfo();
  },
  mounted() {
    // $("#div_EditShipmentModal").modal("show");
  },
  computed: {
    /*completeAbandonButtonVisible() {
      return !["2","3","4"].includes(this.shipment?.OrderStatus);
    },
    cancelOrderItemsButtonVisible() {
      return !this.shipment?.PendingOrder?.every(order => ["2", "3", "4"].includes(order.Status));
    }*/
  },
  watch: {
    /*pageSize: function (val) {
      this.getInstallments(this.pageIndex, this.pageSize);
    },*/
  },
  components: {
    simplebar, 'paginate': Paginate, datePicker: VuePersianDatetimePicker,
  }
};
</script>

<style>
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  margin-bottom: 5px;
  text-transform: lowercase;
  font-variant: small-caps;
  text-align: right !important;
  direction: rtl !important;
  padding: 2px;
}

.text-right {
  direction: rtl !important;
  text-align: right !important;
}

.reset {
  all: revert;
}

.vpd-icon-btn {
  margin-bottom: 0px !important;
}

.mp-custom-input-text {
  font-size: 25px;
  direction: ltr;
  text-align: left;
}

.table-responsive {
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
}

th {
  font-weight: initial !important;
}

.highlight {
  background-color: #B2FF59;
}

.bg-white {
  color: initial;
}

.disabled-row {
  background-color: #f0f0f0;
  color: #919090;
  pointer-events: none;
}

</style>
